import { useCallback } from 'react';

import { mutate } from 'swr';

import { STATUSES } from 'commons';
import { messages, swrKeys } from 'helpers';
import { useAuth } from 'hooks';
import { consignmentService } from 'services';
import { Consignment } from 'types';

const { RESERVED_BY_STORE } = STATUSES;

interface AcceptConsignmentParams {
  consignment: Consignment;
  setSelectedConsignment: (consignment: Consignment | null) => void;
}

export function useAcceptConsignment() {
  const { selectedStore, user } = useAuth();
  const { isAdmin } = user;
  const store = selectedStore?.name ?? '';

  const acceptConsignment = useCallback(
    async (props: AcceptConsignmentParams) => {
      const { consignment, setSelectedConsignment } = props;

      if (!consignment) return;

      if (!store) {
        return messages([{ errorCode: 'FRONT-RE-STORE-NOT-FOUND' }]);
      }

      const selectedConsignment = { ...consignment };
      const { consignmentCode } = consignment;

      if (!isAdmin) {
        await consignmentService.putReserve({ consignmentCode, store });
        await mutate(swrKeys.consignments({ key: store }));
        selectedConsignment.consignmentStatus = RESERVED_BY_STORE.value;
      }

      setSelectedConsignment(selectedConsignment);
    },
    [store, isAdmin]
  );

  return { acceptConsignment };
}
